import React from 'react';
import TextFieldWithCheck from './TextFieldWithCheck';
import ComboField from './ComboField';
import { FormHelperTextProps, Grid } from '@mui/material';

type DocumentType = 'DNI' | 'NIE' | 'Pasaporte';
interface DocumentFieldProps {
  value: string;
  documentType?: DocumentType;
  onValueChange: (value: string) => void;
  onTypeChange: (type: DocumentType) => void;
  onBlurValue?: () => void;
  onBlurType?: () => void;
  errorValue?: boolean;
  helperTextValue?: string;
  errorType?: boolean;
  helperTextType?: string;
  FormHelperTextProps?: Partial<FormHelperTextProps>;
}

const DOCUMENT_TYPES: Array<DocumentType> = ['DNI', 'NIE', 'Pasaporte'];

const DocumentField: React.FC<DocumentFieldProps> = ({
  value,
  documentType,
  onValueChange,
  onTypeChange,
  onBlurValue,
  onBlurType,
  errorValue,
  helperTextValue,
  errorType,
  FormHelperTextProps,
  helperTextType,
}) => {
  return (
    <Grid container spacing={0} alignItems="flex-start">
      <Grid item xs={12} sm={4}>
        <ComboField
          value={documentType || null}
          onChange={(_, newType) => {
            if (newType) onTypeChange(newType as DocumentType);
          }}
          id="document_type"
          options={DOCUMENT_TYPES}
          label="Tipo de documento(*)"
          name="document_type"
          onBlur={onBlurType}
          error={errorType}
          helperText={helperTextType}
        />
      </Grid>

      {/* Document value field */}
      <Grid item xs={12} sm={8}>
        <TextFieldWithCheck
          id="document_value"
          name="document_value"
          label={documentType ? `${documentType}(*)` : 'Elige un tipo de documento'}
          variant="outlined"
          value={value}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onValueChange(e.target.value)}
          onBlur={onBlurValue}
          helperText={helperTextValue}
          error={errorValue}
          disabled={!documentType}
          FormHelperTextProps={FormHelperTextProps}
          fullWidth
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: helperTextValue ? '#d32f2f' : 'inherit',
              color: helperTextValue || errorValue ? '#d32f2f' : 'inherit',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: helperTextValue ? '#d32f2f' : 'inherit',
              color: helperTextValue || errorValue ? '#d32f2f' : 'inherit',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: helperTextValue ? '#d32f2f' : 'primary.main',
              color: helperTextValue || errorValue ? '#d32f2f' : 'primary.main',
            },
          }}
        />
      </Grid>
    </Grid>
  );
};

export default DocumentField;
